import React from 'react';
import { isEmpty } from 'lodash';
import { toast } from 'react-toastify';

import { functions } from '../firebase';
import ModalButton from './ModalButton';
import ModelFormModal from './modals/ModelFormModal';
import useTenant from './hooks/useTenant';
import useFirebaseUser from './hooks/useFirebaseUser';

const sendBulkEmail = functions.httpsCallable('sendBulkEmail');

/**
 * 汎用的な一括メール送信ボタン
 *
 * @param {Object} props
 * @param {Array<{email: string, name?: string, id: string, uid: string}>} props.recipients - 宛先リスト（email, id, uidが必須）
 * @param {string} props.sourceType - 送信元の種類（surveyAnswer, troubleInquiry など）
 * @param {Function} props.onSuccess - 送信成功時のコールバック
 * @param {string} [props.className] - 追加のCSSクラス
 */
export default function BulkEmailButton({ recipients, sourceType, onSuccess, className }) {
  const tenant = useTenant();
  const { firebaseUser } = useFirebaseUser();

  const onClickSend = async ({ subject, text }, { onClickClose }) => {
    const confirmMessage = `${recipients.length}件のメールを送信しますか？\n\n件名: ${subject}\n本文: ${text}`;

    if (!window.confirm(confirmMessage)) {
      return;
    }

    try {
      const result = await sendBulkEmail({
        tenantId: tenant.id,
        recipients: recipients.map(_ => ({ email: _.email, name: _.name, uid: _.uid })),
        subject,
        text,
        sourceType,
        sourceIds: recipients.map(_ => _.id),
        createdBy: {
          uid: firebaseUser.uid,
          email: firebaseUser.email,
          displayName: firebaseUser.displayName,
        },
      });

      toast.success(`${result.data.sentCount}件のメールを送信しました`);
      onClickClose();
      onSuccess?.();
    } catch (error) {
      console.error(error);
      toast.error('メール送信に失敗しました');
    }
  };

  if (recipients.length === 0) {
    return null;
  }

  return (
    <ModalButton
      className={className}
      Modal={ModelFormModal}
      modalProps={{
        title: '一括メール送信',
        submitLabel: '送信',
        fields: {
          subject: {
            label: '件名',
            type: 'string',
            validations: {
              required: _ => !isEmpty(_),
            },
          },
          text: {
            label: '本文',
            type: 'text',
            validations: {
              required: _ => !isEmpty(_),
            },
          },
        },
        onSubmit: onClickSend,
      }}
    >
      {recipients.length}件にメール送信
    </ModalButton>
  );
}
